import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row justify-left items-center" }
const _hoisted_2 = { class: "green-name-text" }
const _hoisted_3 = { class: "green-name-text" }
const _hoisted_4 = { class: "row no-wrap" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = {
  class: "row justify-between items-center",
  style: {"width":"100%"}
}
const _hoisted_7 = { class: "text-primary" }
const _hoisted_8 = { class: "text-grey-7" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!

  return (_ctx.job.Id)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "job-container",
        style: _normalizeStyle(`border-left-color: ${_ctx.jobStatus.color}`)
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.job.Worker?.Name), 1),
          _createVNode(_component_q_icon, {
            color: "accent",
            name: "chevron_left",
            size: "sm"
          }),
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.job.Creator?.Name), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", { innerHTML: _ctx.getMessage }, null, 8, _hoisted_5)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.getFinishedTime), 1),
          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.getCreateTime), 1)
        ])
      ], 4))
    : _createCommentVNode("", true)
}